import React, { useState, useEffect } from "react";
import {
  ClientHoldingNew,
  CombineLedgerReportNew,
  ContractListReportNew,
  DividendReportNew,
  DPReportNew,
  LedgerNew,
  LeviesReportNew,
  LtcgReportNew,
  MorningLimitReportNew,
  MTFDelayPaymentNew,
  MTFDetailsNew,
  PnlReportNew,
  TaxReportNew,
  TradeSummaryNew,
  AgingReportNew,
  InterestReportNew,
  FundTransReportNew,
  CostReportTradeNew,
  Last10TradeTransReportNew,
  YieldReportNew,
  PledgeMasterReportNew,
} from "./Reports"; // Assuming all components are exported from a single file
import Previous from "../../../asset/images/prev_arrow.svg";
import Next from "../../../asset/images/next.svg";
import DarkPrevious from "../../../../src/asset/images/arrow_left-dark.svg";
import DarkNext from "../../../../src/asset/images/arrow_right-dark.svg";
import { Constants } from "../../../CommonMethhods/Constants";

function ReportNew(props) {
  const [stockReportName, setStockReportName] = useState("clientholding");
  const partnerRole = localStorage.getItem("partnerRole");
  const partnerRoleNew = localStorage.getItem("partnerRoleNew");


  useEffect(() => {
    if (partnerRole === "Partner" || partnerRoleNew === "Partner") {
      localStorage.setItem("clientCode", localStorage.getItem("ClientId2"));
    }
  }, [partnerRole]);

  const reports = {
    clientholding: <ClientHoldingNew />,
    tradesummary: <TradeSummaryNew />,
    ledgerreport: <LedgerNew />,
    morninglimitreport: <MorningLimitReportNew />,
    levies: <LeviesReportNew />,
    combineledger: <CombineLedgerReportNew />,
    ltcg: <LtcgReportNew />,
    pnlreport: <PnlReportNew />,
    mtfdetails: <MTFDetailsNew />,
    mtfdelaypayment: <MTFDelayPaymentNew />,
    interest: <InterestReportNew />,
    tax: <TaxReportNew />,
    contractlist: <ContractListReportNew />,
    dividend: <DividendReportNew />,
    dp: <DPReportNew />,
    agingreportnew: <AgingReportNew />,
    fundtransactionreportnew: <FundTransReportNew />,
    costreportnew: <CostReportTradeNew />,
    view_last_10_reportnew: <Last10TradeTransReportNew />,
    yield_report: <YieldReportNew />,
    pledge_master_report: <PledgeMasterReportNew />,
  };

  const renderReport = () => reports[stockReportName] || <TradeSummaryNew />;

  const handleStockOnChange = (e) => {
    setStockReportName(e.target.value);
  };

  const scroll = (direction) => {
    document.getElementById("nav-tab").scrollLeft +=
      direction === "right" ? 200 : -200;
  };

  const reportButtons = [
    {
      id: "client-holding-tab",
      value: "clientholding",
      text: "Client Holding Statement Report",
    },
    {
      id: "trade-summary-tab",
      value: "tradesummary",
      text: "Trade Summary Report",
    },
    partnerRole !== "Partner" && partnerRoleNew !== "Partner" && {
      id: "ledger-tab",
      value: "ledgerreport",
      text: "Financial Ledger Report",
    },
    partnerRole !== "Partner" && partnerRoleNew !== "Partner" && {
      id: "morning-limit",
      value: "morninglimitreport",
      text: "Morning Limit Report",
    },
    partnerRole !== "Partner" && partnerRoleNew !== "Partner" && {
      id: "levies-report",
      value: "levies",
      text: "Levies Report",
    },
    { id: "pnl-report", value: "pnlreport", text: "PnL Report" },
    { id: "mtf-details", value: "mtfdetails", text: "MTF Details Report" },
    { id: "mtf-delay", value: "mtfdelaypayment", text: "Delay Payment Report" },
    { id: "interest-report", value: "interest", text: "Interest Report" },
    partnerRole !== "Partner" && partnerRoleNew !== "Partner" && {
      id: "tax-report",
      value: "tax",
      text: "Tax Report",
    },
    partnerRole !== "Partner" && partnerRoleNew !== "Partner" && {
      id: "dividend-report",
      value: "dividend",
      text: "Dividend Report",
    },
    { id: "dp-report", value: "dp", text: "DP Transaction" },
    partnerRole !== "Partner" && partnerRoleNew !== "Partner" && {
      id: "contract-list",
      value: "contractlist",
      text: "Contract List Report",
    },
    {
      id: "combine-ledger",
      value: "combineledger",
      text: Constants.Combine_Ledger_Report,
    },
    partnerRole !== "Partner" && partnerRoleNew !== "Partner" && {
      id: "ltcg-report",
      value: "ltcg",
      text: "Days To Long Term Report",
    },
    partnerRole !== "Partner" && partnerRoleNew !== "Partner" && {
      id: "aging-report",
      value: "agingreportnew",
      text: "Aging Report",
    },
    partnerRole !== "Partner" && partnerRoleNew !== "Partner" && {
      id: "fundtransaction-report",
      value: "fundtransactionreportnew",
      text: "Fund Transaction Report",
    },
    partnerRole !== "Partner" && partnerRoleNew !== "Partner" && {
      id: "cost-report",
      value: "costreportnew",
      text: "Cost Report",
    },
    partnerRole !== "Partner" && partnerRoleNew !== "Partner" && {
      id: "view-last-10-report",
      value: "view_last_10_reportnew",
      text: "View Last 10 Transaction",
    },
    partnerRole !== "Partner" && partnerRoleNew !== "Partner" && {
      id: "yield_report",
      value: "yield_report",
      text: "Yield Report",
    },
    partnerRole !== "Partner" && partnerRoleNew !== "Partner" && {
      id: "pledge_master_report",
      value: "pledge_master_report",
      text: "Pledge Master Report",
    },
  ].filter(Boolean);

  return (
    <>
      <div className="main-ul">
        <img
          alt="scroll-left"
          src={Previous}
          onClick={() => scroll("left")}
          className="prev-img"
        />
        <img
          alt="scroll-left"
          src={DarkPrevious}
          onClick={() => scroll("left")}
          className="dark-prev-img"
        />

        <ul
          className="nav report-new-tabs page-tabs"
          id="nav-tab"
          role="tablist"
        >
          {reportButtons.map(({ id, value, text }) => (
            <li key={id} className="nav-item">
              <button
                className={`nav-link ${
                  id === "client-holding-tab" && "active"
                } `}
                id={id}
                data-toggle="tab"
                data-target={`#${id}`}
                role="tab"
                aria-controls={id}
                aria-selected="false"
                value={value}
                onClick={handleStockOnChange}
              >
                {text}
              </button>
            </li>
          ))}
        </ul>

        <img
          alt="scroll-right"
          onClick={() => scroll("right")}
          src={Next}
          className="next-img"
        />
        <img
          alt="scroll-right"
          onClick={() => scroll("right")}
          src={DarkNext}
          className="dark-next-img"
        />
      </div>
      <div className="tab-content report-new-tabPane" id="nav-tabContent">
        {renderReport()}
      </div>
    </>
  );
}

export default ReportNew;
